import { Icon } from "@iconify/react";
import { onRemove } from "../helper/method";

export default function PreviewFile({
  url,
  id,
  setFile,
}: {
  url: string;
  id: string;
  setFile: React.Dispatch<
    React.SetStateAction<
      {
        file: File | undefined;
        id: string;
        fileUrl: string;
      }[]
    >
  >;
}) {
  return (
    <div className="w-full h-full rounded-xl overflow-hidden relative">
      <button
        onClick={() => onRemove(id, setFile)}
        className="absolute w-fit h-fit flex-center left-2 top-2 cursor-pointer"
      >
        <Icon icon={"ic:baseline-cancel"} className="w-8 h-8 text-error-500" />
      </button>
      <img src={url} alt="" className="w-full h-full object-cover" />
    </div>
  );
}
